export const SCHEDULE_DATE_OPTION_COUNT = 14;

/** Same shape as `normalizeScheduleDateLabel` input in App.js (e.g. Thu, 30 Apr, 26). */
export function formatCheckoutScheduleDateLabel(d) {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const dow = days[d.getDay()];
  const dom = d.getDate();
  const mon = months[d.getMonth()];
  const yy = d.getFullYear() % 100;
  return `${dow}, ${dom} ${mon}, ${String(yy).padStart(2, '0')}`;
}

export function buildCheckoutScheduleDateOptions() {
  const out = [];
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  for (let i = 0; i < SCHEDULE_DATE_OPTION_COUNT; i += 1) {
    const day = new Date(start);
    day.setDate(start.getDate() + i);
    out.push(formatCheckoutScheduleDateLabel(day));
  }
  return out;
}
